class AddEditSimulationDataTypeController {
    constructor(SimulationDataServiceApi, toastr, ScriptInjectionService) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                action: 'Create'
            };
            this.data = {
                simulationDataType: null
            };
            this.data.simulationDataType = angular.copy(this.resolve.simulationDataType);
            if (this.data.simulationDataType === null || angular.isUndefined(this.data.simulationDataType.TypeName)) {
                this.data.simulationDataType = {
                    Id: -1,
                    TypeName: '',
                    DisplayName: '',
                    FormlyFilename: '',
                    Icon: '',
                    SimulationDataTypeUid: '',
                    Version: '',
                    TypeDefinitionJson: ''
                };
                this.state.action = 'Create';
            }
            else {
                this.state.action = 'Update';
            }
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.save = () => {
            this.SimulationDataServiceApi.saveType(this.data.simulationDataType).then((response) => {
                if (!angular.isUndefined(response) && response.status === 200) {
                    this.resolve.simulationDataType = this.data.simulationDataType;
                    this.close({ $value: this.state.action + 'd' });
                }
                else {
                    if (response.data && response.data.messages && response.data.messages.length > 0)
                        this.toastr.error(response.data.messages[0], 'Error Saving');
                    else
                        this.toastr.error('Please check all details are correct', 'Error Saving');
                }
            });
        };
        this.SimulationDataServiceApi = SimulationDataServiceApi;
        this.toastr = toastr;
        this.ScriptInjectionService = ScriptInjectionService;
    }
}
angular.module('app').component('addEditSimulationDataTypeModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/SimulationData/admin/add-edit-simulation-data-type-modal.tpl.html',
    controllerAs: 'vm',
    controller: AddEditSimulationDataTypeController
});
